import React from "react";
import "./HeroSectionV2.css";
import { useLanguage } from "../context/LanguageContext";

interface HeroSectionProps {
    titleEn: string;
    titleDa: string;
    descriptionEn: string;
    descriptionDa: string;
    imageSrc: string;

    // optional (kan bruges senere)
    badgeText?: string;      // fx "TEAM"
    logoSrc?: string;        // fx event logo
}

const HeroSectionV2: React.FC<HeroSectionProps> = ({
    titleEn,
    titleDa,
    descriptionEn,
    descriptionDa,
    imageSrc,
    badgeText,
    logoSrc,
}) => {
    const { language, setLanguage } = useLanguage();

    return (
        <section className="heroV2">
            {/* baggrundsbillede */}
            <div
                className="heroV2__bg"
                style={{ backgroundImage: `url(${imageSrc})` }}
                aria-hidden="true"
            />

            {/* overlays */}
            <div className="heroV2__overlay" aria-hidden="true" />
            <div className="heroV2__glow" aria-hidden="true" />

            {/* r�de striber */}
            <div className="heroV2__stripes" aria-hidden="true">
                <span />
                <span />
                <span />
            </div>

            <div className="heroV2__content">
                <div className="heroV2__top">
                    <div className="heroV2__top">
                        {logoSrc ? <img className="heroV2__logo" src={logoSrc} alt="Logo" /> : null}
                        {badgeText ? <div className="heroV2__badge">{badgeText}</div> : null}
                    </div>

                </div>

                <h1 className="heroV2__title">{language === "en" ? titleEn : titleDa}</h1>

                <p className="heroV2__desc">
                    {language === "en" ? descriptionEn : descriptionDa}
                </p>

                {/* sprogknapper som i din gamle */}
                <div className="heroV2__lang">
                    <button
                        onClick={() => setLanguage("en")}
                        className={`heroV2__langBtn ${language === "en" ? "isActive" : ""}`}
                    >
                        ENGLISH
                    </button>
                    <button
                        onClick={() => setLanguage("da")}
                        className={`heroV2__langBtn ${language === "da" ? "isActive" : ""}`}
                    >
                        DANSK
                    </button>
                </div>
            </div>
        </section>
    );
};

export default HeroSectionV2;
